const ScrollToAnchor = () => {
  if (
    typeof window === "undefined" ||
    typeof document === "undefined" ||
    document === undefined
  ) {
    return;
  }
  const hash = window.location.hash.replace("#", "");
  const div = window.document.getElementById(hash);
  if (div) {
    const rect = div.getBoundingClientRect();
    const offset = rect.y - 200 + window.scrollY;
    scrollTo(0, offset);
  } else {
    scrollTo(0,0)
  }
};

export default ScrollToAnchor;
